export const COMPONENT_TREE_SECTIONS = {
    STANDARD: 'Standard Components',
    CLIENT: 'Components',
    SHARED: 'Global Content',
    ATOMS: 'Basic Elements',
    STRUCTURAL: 'Structural Components',
};
